import { Injectable } from '@angular/core';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';
import { ICostUnit } from '../models/cost-unit.model';

const BASE_URL: string = 'cost-unit';

@Injectable({
    providedIn: 'root'
})
export class CostUnitResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllCostUnits(): Observable<ICostUnit[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public createCostUnit(costUnit: ICostUnit): Observable<ICostUnit> {
        return this.myCostAccountingRequestService.post(BASE_URL, costUnit);
    }

    public updateCostUnit(costUnit: ICostUnit): Observable<ICostUnit> {
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${costUnit.id}`, costUnit);
    }

    public deleteCostUnit(costUnitId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${costUnitId}`);
    }

}
